import { render, staticRenderFns } from "./Jiayue.vue?vue&type=template&id=596164f2&scoped=true"
import script from "./Jiayue.vue?vue&type=script&lang=js"
export * from "./Jiayue.vue?vue&type=script&lang=js"
import style0 from "./Jiayue.vue?vue&type=style&index=0&id=596164f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596164f2",
  null
  
)

export default component.exports